//-------------------------------------------------------------------------------------------
// Used for the validation of the file size and content type of a input type=file element
// ToDo: add extension checking
//   - the current code only knows how to check for content type, extension need to be added
//     because not all extensions have a corresponding content type
// History:
//   2021-04-07 - Code updated to add invalid-* classes for each of the min, max file size
//     and content type checks
//   2021-10-14 - Added validation for unique filenames amongst file upload fields in the same
//     'data-filegroup' attribute value.
//-------------------------------------------------------------------------------------------
import Foundation from 'foundation-sites';
import jQuery from 'jquery';

Foundation.Abide.defaults.validators['validate_input_file'] = validateInputFile;

//
// Check filename uniquness in the given filegroup.
//
function isUniqueFilenamesInGroup(filegroup, filename, finputid)
{
    let file_group_name = filegroup.attr('data-filegroup');

    //Return true if the fileGroup is not named. A named filegroup will be validated for filename uniqueness.
    if (!file_group_name) return true;

    var isUnique = true;
    jQuery('.input-group[data-filegroup='+file_group_name+'] input.upload-input').each(function(i)
    {
        let elem = jQuery(this);
        if (elem.attr('id') != finputid) {
            let files = this.files;
            if (files.length > 0) {
                if (files[0].name == filename) {
                    isUnique = false;
                }
            }
        }
    });

    return isUnique;
}

//
// Check for required min file limit
//
function hasRequiredFileMinLimit(filegroup)
{
    let file_group_name = filegroup.attr('data-filegroup');
    //Return true if the fileGroup is not named. A named filegroup will not validate file inputs as a group.
    if (!file_group_name) return true;

    let file_group_min_required = filegroup.attr('data-filegroup-min-required');
    //Return true if there is no minimum limit.
    if (!file_group_min_required) return true;

    var files_count = 0;
    jQuery('.input-group[data-filegroup='+file_group_name+'] input.upload-input').each(function(i)
    {
        let elem = jQuery(this);
        let files = this.files;
        if (files.length > 0) {
            files_count++;
        }
    });

    if (files_count >= file_group_min_required) {
        return true;
    } 
    
    return false;
}

function validateInputFile(
    $el,      /* jQuery element to validate */
    required, /* is the element required according to the `[required]` attribute */
    parent    /* parent of the jQuery element `$el` */
) {
    var allowed_min_size = $el.attr('data-min-size');
    var allowed_max_size = $el.attr('data-max-size');
    var allowed_content_types = [];
    var allowed_file_extensions = [];
    if ($el.attr('data-allowed-content-types')) {
        allowed_content_types = $el.attr('data-allowed-content-types').toLowerCase().split(';'); /* data-allowed-content-type is a semi-colon delimited string of content-types (not extensions)*/
    }
    if ($el.attr('data-allowed-file-extensions')) {
        allowed_file_extensions = $el.attr('data-allowed-file-extensions').toLowerCase().split(';'); /* data-allowed-file-extensions is a semi-colon delimited string of content-types (not extensions)*/
    }

    var file_group = $el.closest('.input-group');
    file_group.removeAttr('invalid-filegroup-min-required');
    if (!hasRequiredFileMinLimit(file_group)) {
        file_group.attr('invalid-filegroup-min-required', '');
        return false;
    }

    //console.log("allowed_content_types: ", allowed_content_types);
    //console.log("allowed_file_extensions: ", allowed_file_extensions);
    var files = document.getElementById($el.attr("id")).files;
    if (files) {
        var valid = true;
        $el.removeAttr("invalid-file-size-too-small","invalid-file-size-too-large","invalid-content-type","invalid-non-unique-filename");
        
        for (var i = 0; i < files.length; i++) {
            var file = files[i];

            /* files in the same filegroup should not have the same filenames */
            if (!isUniqueFilenamesInGroup( file_group, file.name, $el.attr('id') )) {
                $el.attr('invalid-non-unique-filename', 1);
                valid = false;
            }
            else {
                if (!!allowed_min_size & file.size < allowed_min_size)
                {
                    $el.attr("invalid-file-size-too-small","");
                    valid = false;
                }

                if (!!allowed_max_size & file.size > allowed_max_size)
                {
                    $el.attr("invalid-file-size-too-large","");
                    valid = false;
                } 
                /* logic note: content-type and extension-check is a combined check */
                /* if one if valid, the check is valid */
                /* only if both are invalid does the check become invalid */

                var validContentType = true;
                if (allowed_content_types.length > 0) {
                    validContentType = allowed_content_types.includes(file.type);
                }
                var re = /(?:\.([^.]+))?$/;
                var ext = re.exec(file.name)[1];

                var validExtension = true;
                if (allowed_file_extensions.length > 0) {
                    validExtension = allowed_file_extensions.includes(ext);
                }
                if (!validContentType && !validExtension)
                {
                    $el.attr("invalid-content-type","");
                    valid = false;
                }
            }
        }

        if (valid) {
            $el.attr("aria-invalid", "false");
        } else {
            $el.attr("aria-invalid", "true");
        }
        return valid;
    } else {
        //console.log("no files found");
    }
    return true;
};
